import jsonTranslations from "./translations.json";

export const translation = (key, lang) => {
  return <span dangerouslySetInnerHTML={{__html: jsonTranslations[key] && jsonTranslations[key][lang] ? jsonTranslations[key][lang] : "<span style=\"background-color: red; color: white;\">"+key+"|"+lang+"</span>"}} />;
}
export const textTranslation = (key, lang) => {
  return jsonTranslations[key] && jsonTranslations[key][lang] ? jsonTranslations[key][lang] : key+"|"+lang;
}
